import * as React from "react";
const SvgStable = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M107.037 107.335C114.468 107.335 119.999 101.96 119.999 94.6895C119.999 87.2586 114.624 82.0435 107.037 82.0435C99.6091 82.0435 94.2324 87.2586 94.2324 94.6895C94.2324 102.117 99.6075 107.335 107.037 107.335Z",
      fill: "#E80000"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M44.4424 108.283C65.3317 108.283 78.7505 97.7528 78.7505 81.1095C78.7505 68.2022 70.4281 59.2003 55.652 55.8032L46.6517 53.5955L45.3372 53.2914C37.9001 51.5129 34.2528 49.538 34.2528 43.9158C34.2528 38.9904 38.1598 36.2728 44.7829 36.2728C65.8385 36.2728 73.4704 43.9158 73.4704 43.9158V27.358L73.1996 27.092C71.6761 25.6793 63.5864 19.1195 44.6135 19.1195C24.5731 19.1195 12.0047 29.3076 12.0047 45.2715C12.0047 57.9491 20.1957 66.6944 34.9686 70.3813L44.273 72.6144C52.0854 74.4832 55.9925 76.5214 55.9925 82.4651C55.9925 87.9005 51.7465 90.957 44.273 90.957C22.747 90.9586 12.0047 79.4576 12.0047 79.4576V99.3143L12.2802 99.6057C13.8339 101.148 22.2197 108.283 44.4424 108.283Z",
      fill: "url(#paint0_linear_8045_4026)"
    }
  ),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint0_linear_8045_4026",
      x1: 31899.4,
      y1: -18.2673,
      x2: 31899.4,
      y2: 15706.2,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#9D39FF" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#A380FF" })
  ))
);
export default SvgStable;
